import angular from 'angular';
import assetFinanceSecurities from './assetFinanceSecurities';

export default angular
  .module('fundingDetailsSection.scenes.assetFinanceSecurities', [])
  .component('assetFinanceSecurities', assetFinanceSecurities).name;
